<script>
  import { getTextData } from "./api/getTextData";

  import { path } from "rambda";

  //components

  import Header from "./sections/Header/Header.svelte";
  import HeroSection from "./sections/Hero/HeroSection.svelte";
  import About from "./sections/About/AboutSection.svelte";
  import BenefitsSection from "./sections/Benefits/BenefitsSection.svelte";
  import MaxWidthWrapper from "./components/MaxWidthWrapper.svelte";
  import FeaturesSection from "./sections/Features/FeaturesSection.svelte";
  import ContactsSection from "./sections/Contacts/ContactsSection.svelte";
  import Footer from "./sections/Footer/Footer.svelte";

  let promise = getTextData("./TEXT_DATA.json");
</script>

<svelte:head>
  <link rel="preconnect" href="https://fonts.gstatic.com" />
  <link
    href="https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap"
    rel="stylesheet"
  />
</svelte:head>

{#await promise then textData}
  <main>
    <MaxWidthWrapper>
      <Header />
      <HeroSection
        firstText={path("Hero_Section.HERO_FIRST_TEXT", textData)}
        secondText={path("Hero_Section.HERO_SECOND_TEXT", textData)}
      />
      <About
        headerText={path("About_Section.ABOUT_HEADER", textData)}
        text={path("About_Section.ABOUT_TEXT", textData)}
      />
      <BenefitsSection
        card_1_header={path("Benefits_Section.CARD_1.CARD_1_HEADER", textData)}
        card_1_text={path("Benefits_Section.CARD_1.CARD_1_TEXT", textData)}
        card_2_header={path("Benefits_Section.CARD_2.CARD_2_HEADER", textData)}
        card_2_text={path("Benefits_Section.CARD_2.CARD_2_TEXT", textData)}
        card_3_header={path("Benefits_Section.CARD_3.CARD_3_HEADER", textData)}
        card_3_text={path("Benefits_Section.CARD_3.CARD_3_TEXT", textData)}
      />
      <FeaturesSection
        header={path("Features_Section.FEATURES_HEADER", textData)}
        text={path("Features_Section.FEATURES_TEXT", textData)}
        footerText={path("Features_Section.FOOTER_TEXT", textData)}
      />
      <ContactsSection
        header={path("Contacts_Section.CONTACTS_HEADER", textData)}
        text={path("Contacts_Section.CONTACTS_TEXT", textData)}
      />
      <Footer />
    </MaxWidthWrapper>
  </main>
{/await}

<style>
  :global(body) {
    background: #ffffff;
    font-family: "Nunito Sans", sans-serif;

    --primary-color: rgba(86, 102, 237, 1);

    overflow-x: hidden;
  }

  main {
    /* border: 1px solid red; */
    position: relative;
    overflow-x: hidden;

    margin: auto;
  }

  @media (max-width: 1100px) {
    /* Tablets */
  }

  @media (max-width: 550px) {
    /* Phones */

    :global(body) {
      overflow-x: hidden;
    }

    main {
      overflow-x: hidden;
    }
  }
</style>
